<template>
  <div :id="id" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators" v-if="gallery && gallery.length > 0">
      <button
        type="button"
        :data-bs-target="'#' + id"
        data-bs-slide-to="0"
        class="active"
        aria-current="true"
        aria-label="Slide 1">
      </button>
      <button
        v-for="(img, index) in gallery"
        :key="index"
        type="button"
        :data-bs-target="'#' + id"
        :data-bs-slide-to="index + 1"
        :aria-label="'Slide ' + (index + 2)">
      </button>
    </div>

    <div class="carousel-inner">
      <div class="carousel-item active">

        <div class="zoom-container"
             @mousemove="zoom($event)"
             @mouseleave="resetZoom"
             @touchmove="zoom($event)"
             @touchstart.prevent="locked=true"
             @touchend="resetZoom"
             @contextmenu.prevent>
          <img
            class="d-block w-100 product-image"
            :src="mainImage"
            :alt="mainImageAlt">
        </div>
      </div>

      <div v-for="(img, index) in gallery"
           :key="index"
           class="carousel-item">
        <div class="zoom-container"
             @mousemove="zoom($event)"
             @touchmove="zoom($event)"
             @touchstart.prevent="locked=true"
             @mouseleave="resetZoom"
             @touchend="resetZoom"
             @contextmenu.prevent>
          <img
            v-lazy="mediaUrl + img.img"
            class="d-block w-100"
            :alt="mainImageAlt">
        </div>
      </div>
    </div>

    <template v-if="gallery && gallery.length > 0">
      <button
        aria-label="قبلی"
        class="carousel-control-prev"
        type="button"
        :data-bs-target="'#' + id"
        data-bs-slide="prev">
        <i class="fa fa-arrow-left color-black" aria-hidden="true"></i>
      </button>
      <button
        aria-label="بعدی"
        class="carousel-control-next"
        type="button"
        :data-bs-target="'#' + id"
        data-bs-slide="next">
        <i class="fa fa-arrow-right color-black" aria-hidden="true"></i>
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ProductImageCarousel',
  props: {
    id: { type: String, required: true },
    mainImage: { type: String, required: true },
    mainImageAlt: { type: String, required: true },
    gallery: { type: Array, default: () => [] },
    mediaUrl: { type: String, required: true }
  },
  data () {
    return {
      locked: false
    }
  },
  watch: {
    locked (to, from) {
      if (to) {
        document.body.style = 'overflow:hidden'
      } else {
        document.body.style = 'overflow:auto'
      }
    }
  },
  onmounted () {
    document.body.style = 'overflow:auto'
  },
  methods: {
    zoom (event) {
      const img = event.currentTarget.querySelector('img')
      const { left, top, width, height } = event.currentTarget.getBoundingClientRect()

      let clientX, clientY
      if (event.type.startsWith('touch')) {
        clientX = event.touches[0].clientX
        clientY = event.touches[0].clientY
      } else {
        clientX = event.clientX
        clientY = event.clientY
      }

      const x = ((clientX - left) / width) * 100
      const y = ((clientY - top) / height) * 100

      img.style.transformOrigin = `${x}% ${y}%`
      img.style.transform = 'scale(2)'
    },
    resetZoom (event) {
      const img = event.currentTarget.querySelector('img')
      img.style.transform = 'scale(1)'
      img.style.transformOrigin = 'center center'
      this.locked = false
    }
  }
}
</script>

<style scoped>
#carouselProduct {
  width: -webkit-fill-available;
  margin: 0px;
}

.carousel-indicators [data-bs-target] {
  background-color: #575757;
}

.product-image {
  aspect-ratio: 1/1;
}

.carousel-control-prev,
.carousel-control-next {
  width: 10%;
}

.carousel-control-prev i,
.carousel-control-next i {
  font-size: 25px;
}

@media (max-width: 768px) {
  #carouselProduct {
    margin: 0 !important;
  }
}

.carousel-item {
  background: #ebebeb;
  border-radius: 24px;
}

/* Zoom */
.zoom-container {
  overflow: hidden;
  position: relative;
}
.zoom-container img {
  transition: transform 0.2s ease;
  cursor: zoom-in;
}

</style>
